import 'react';
import { formatNumber } from '@atc/string-fns';
import 'prop-types';
import { Text } from 'reaxl';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
const textFormatting = {
  lender: {
    paymentSize: 700,
    suffixSize: 200,
    asterisk: true,
    suffixWeight: null
  },
  compact: {
    paymentSize: 200,
    suffixSize: 200,
    asterisk: true,
    suffixWeight: 'normal',
    prefix: true
  },
  withRates: {
    suffixSize: 200,
    suffixWeight: 'normal'
  },
  withPayment: {
    paymentSize: 400,
    suffixSize: 200,
    asterisk: true,
    suffixWeight: 'normal',
    prefix: true
  },
  button: {
    paymentSize: 100,
    suffixSize: 100,
    prefix: true
  },
  ribbon: {
    paymentSize: null,
    paymentWeight: null,
    suffixSize: null,
    suffixWeight: null
  },
  error: {
    paymentSize: 700,
    suffixSize: 200,
    asterisk: true,
    suffixWeight: null,
    paymentValue: '---'
  },
  withRedesign: {
    paymentSize: 700,
    suffixSize: null,
    asterisk: true,
    suffixWeight: 'normal'
  }
};

/**
 *  Displays a formatted monthly payment value. `uiContext` modifies
 *  size, weight, and positioning of currency symbol
 */
function Payment(_ref) {
  let {
    payment,
    textColor,
    uiContext
  } = _ref;
  const {
    paymentSize = 500,
    paymentWeight = 'ultra-bold',
    prefix = false,
    asterisk = false,
    suffixSize = 300,
    suffixWeight = 'bold',
    paymentValue = formatNumber({
      value: Math.floor(payment),
      style: prefix ? 'currency' : ''
    })
  } = textFormatting[uiContext] ?? {};
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Text, {
      ...(paymentSize ? {
        size: paymentSize
      } : {}),
      ...(paymentWeight ? {
        weight: paymentWeight
      } : {}),
      ...(textColor ? {
        color: textColor
      } : {}),
      children: [!prefix && /*#__PURE__*/jsx(Text, {
        ...(paymentSize ? {
          size: paymentSize
        } : {}),
        children: "$"
      }), paymentValue]
    }, `payment-${payment}`), /*#__PURE__*/jsxs(Text, {
      ...(paymentSize ? {
        size: suffixSize
      } : {}),
      ...(paymentWeight ? {
        weight: suffixWeight
      } : {}),
      ...(textColor ? {
        color: textColor
      } : {}),
      children: ["/mo.", asterisk && '*']
    }, `payment-${payment}-monthly`)]
  });
}
export { Payment as default };
